import {
  StyledSection,
  StyledTableAligner,
  StyledTableWrapper,
  StyledTitle,
} from './styles';
import { whyChooseRFData } from './WhyChooseRF.data';

export const WhyChooseRF = () => {
  return (
    <StyledSection width="small">
      <StyledTitle variant="display_sm">{whyChooseRFData.title}</StyledTitle>

      <StyledTableAligner>
        <StyledTableWrapper>
          <table>
            <thead>
              <tr>
                {whyChooseRFData.headers.map((header, index) => (
                  <th key={index}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {whyChooseRFData.rows.map((row, index) => (
                <tr key={index}>
                  <td
                    dangerouslySetInnerHTML={{ __html: row.syntheticPlatforms }}
                  />
                  <td dangerouslySetInnerHTML={{ __html: row.rumbleFish }} />
                </tr>
              ))}
            </tbody>
          </table>
        </StyledTableWrapper>
      </StyledTableAligner>
    </StyledSection>
  );
};
